<template>
    <div v-if="this.urldata">
        <div class="img-box">
            <img src="../../../static/img/mail/marshalling.png">
        </div>
        <div class="text-tab">正在打开麦德通微信小程序~</div>
        <div class="text-tab1">是否继续？</div>
        <div class="button-tab">
            <div class="button-tab1" @click="skip()"><div class="button-tab2">继续</div></div>
        </div>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import {linkToProgram } from "@/api/land.js";
export default {
    data() {
        return {
            urldata: ''
        };
    },
    created() {
    },
    mounted() {
        let phone = navigator.userAgent;//设备机型的相关信息
        phone = phone.substring(phone.indexOf('(')+1,phone.indexOf(';'));//处理信息，输出phone
        if ((phone.indexOf('Windows') == -1 && phone.indexOf('Macintosh') == -1 && phone.indexOf('iPad') == -1)) {
            //  linkToProgram({path:'minePages/pages/renew/index'}).then(res =>{
                 // 邮件跳转
            linkToProgram({path:'minePages/pages/loginLoading/index',formType:'h5',phone:this.$route.query.mailName,toPage:'/minePages/pages/renew/index'}).then(res =>{
            if (res.code == 0) {
                this.urldata =  res.data
                this.skip()
            } else {
                this.$toast({message:'系统繁忙，请稍后重试'})
            }
            }).catch(() =>{
                this.$toast({message:'系统繁忙，请稍后重试'})
            })
        } else {
            // window.location.href = 'https://user.ippmaster.com/renewalPage';
            // 邮件跳转
            let name = this.$route.query.mailName || ''
            let h = window.location.href
            let url = ''
            name = name ? '?mailName='+name : '' 
            if(h.indexOf('https://uat-m.ippmaster.com') != -1) {
                url = `https://uat-user.ippmaster.com/renewalPage${name}`
            } else if (h.indexOf('https://m.ippmaster.com') != -1) {
                url = `https://user.ippmaster.com/renewalPage${name}`
            } else if(h.indexOf('http://m1.ost.com') != -1) {
                url = `http://mc1.ost.com/renewalPage${name}`
            } else {
                url = `https://uat-user.ippmaster.com/renewalPage${name}`
            }
            window.location.href = url
        }
    },
    components: {},
    methods: {
        skip(){
            window.location.href = this.urldata
        }
    }
};
</script>
<style scoped>
.img-box {
    padding-top: 96px;
    
}
.img-box img{
    width: 90px;
    height: 90px;
}
.text-tab{
    font-size: 16px;
    padding-top: 60px;
    line-height: 22px;
}
.text-tab1{
    font-size: 16px;
    padding-top: 33px;
    line-height: 33px;
}
.button-tab{
    position: fixed;
    bottom: 0;
    display: flex;
    height: 1.2rem;
    width: 100%;
    /* padding:0px 15px 15px 15px; */
}
.button-tab1{
    background-color: #4FA9FD;
    width: 100%;
    border-radius: 5px;
    margin: 0 15px 15px 15px;
}
.button-tab2{
    width: 100%;
    font-size: 16px;
    line-height: 1rem;
    color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/views/mail/mail.vue